import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EReportColumnHeader,
  EParamChannelTypeGlobal,
  IReportingSearchTermsTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDASearchTermsReportTableFilters,
  TPPAdvertiserId,
  TSPSearchTermsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingSearchTermsTableV3({
  advertiserId,
  retailerId,
  campaignId,
  adGroupId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TSPSearchTermsReportTableFilters | TDASearchTermsReportTableFilters) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingSearchTermsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingSearchTermsTable_${channelType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3
        .advertiserReporting()
        .getAdvertiserSearchTermsReportTable(
          advertiserId,
          generateCorrelationId(),
          retailerId,
          campaignId,
          adGroupId,
          channelType as EParamChannelTypeGlobal,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow as unknown as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          pageLimit,
          pageOffset,
          filterBy,
          filterOperation,
          filterValue,
          name
        )
    },
    { suspense, enabled }
  )
}
